(() => {
  'use strict';
  if (window.AWReplicaFormAttributionP2?.version) return;

  const VERSION = '1.0.0';
  const clean = (value = '') => String(value || '').trim();
  const propertyName = (name) => `properties[${name}]`;
  const propertyInput = (form, name) => form?.elements?.namedItem?.(propertyName(name)) || null;

  const setHidden = (form, name, value) => {
    const safe = clean(value);
    if (!safe) return false;
    let input = propertyInput(form, name);
    if (input?.value) return false;
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = propertyName(name);
      form.appendChild(input);
    }
    input.value = safe.slice(0, 180);
    input.dataset.awReplicaFormAttributionP2 = 'true';
    return true;
  };

  const isCartForm = (form) => {
    if (!form?.matches?.('form')) return false;
    const action = clean(form.getAttribute('action') || form.action);
    return /\/cart\/add(?:\.js)?(?:[?#]|$)/i.test(action);
  };

  const decorate = (form) => {
    if (!isCartForm(form)) return false;
    const existing = propertyInput(form, '_AW Replica ID');
    if (existing?.value) return false;

    const bridge = window.AWReplicaAttributionBridge;
    if (!bridge?.contextFor || !bridge?.matchingReplica) return false;

    let context = null;
    try { context = bridge.contextFor(new FormData(form)); }
    catch (_) { context = null; }
    if (!context || context.existingReplicaId) return false;

    let replica = null;
    try { replica = bridge.matchingReplica(context); }
    catch (_) { replica = null; }
    if (!replica?.id) return false;

    const changed = setHidden(form, '_AW Replica ID', replica.id);
    setHidden(form, '_AW Replica Label', replica.nickname || replica.model || 'Réplique AW');
    if (context.buildId) setHidden(form, '_AW Build ID', context.buildId);
    setHidden(form, '_AW Purchase Context', 'exact_pdp_form_match');
    if (changed) form.dataset.awReplicaFormAttribution = 'exact-bridge-match';
    return changed;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target?.closest?.('form[action*="/cart/add"]');
    if (form) decorate(form);
  }, true);

  window.AWReplicaFormAttributionP2 = {
    version: VERSION,
    decorate,
    policy: 'existing-aw-replica-bridge-match-only;submit-capture-before-ajax-formdata;survives-native-form-submit-fallback;never-overwrite-existing-replica-id;never-infer-without-bridge-match'
  };
})();
